module.exports = __webpack_public_path__ + "media/components/assets/img/bg/booking-fields-flyo-87700a976dd24ca2f0c9e3da6e7b563a.svg";